__webpack_require__.p = "/wp-content/plugins/ppsposter-react/react/build/static/media/";